import {I18n} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'

export enum UIUrlParameterNames {
    EnterMatchmaking = 'matchmakingqueue',
    EnterBotGame = 'enterbotgame',
    VideoAdTesting = 'bidtest',
    Campaign = 'campaign',
    Lobby = 'lobby',
    Spectate = 'spectate',
    MainPage = 'mainpage', // used in ejs
    SelectMode = 'selectmode',
    SuppressPopupsOnLoad = 'suppresspopupsonload',
    DiscordLeaderboard = 'discordleaderboard',
    DiscordStore = 'discordstore',
    DiscordAbout = 'discordabout',
    DiscordCareers = 'discordcareers',
    DiscordChampionship25 = 'discordchampionship25',
    DiscordChampionship26 = 'discordchampionship26',
    DiscordCommunity = 'discordcommunity',
    DiscordFAQ = 'discordfaq',
    DiscordPrivacyPolicy = 'discordprivacypolicy',
    DiscordPatchNotes = 'discordpatchnotes',
    DiscordProfile = 'discordprofile',
    DiscordGifting = 'discordgifting',
    DiscordValues = 'discordvalues',
    DiscordValuesExamples = 'discordvaluesexamples',
    DiscordTerms = 'discordterms',
    DiscordPressKit = 'discordpresskit',
    DiscordRefundPolicy = 'discordrefundpolicy',
    DiscordShareActivity = 'discord-share-activity',
    MobileLeaderboard = 'mobileleaderboard',
    MobileLobby = 'mobilelobby',
    MobileHomepage = 'mobilehomepage',
    MobileStore = 'mobilestore',
    MobileProfile = 'mobileprofile',
    MobileMore = 'mobilemore',
    ReferralInvitation = 'share',
    MobileReactivation = 'mobilereactivation',
    MobileImageSharing = 'mobileimagesharing',
    ReconnectGame = 'reconnectgame',
}

export class UIUrlController {
    static accessGameFromLink(action: (roomId: string) => void) {
        const roomId = this.getRoomIdFromUrl()
        if(roomId == undefined) return

        action(roomId)
    }

    static getRoomIdFromUrl(): string | undefined {
        if(typeof window.location.hash == 'undefined') return undefined
        if(window.location.hash == '') return undefined
        if(!this.isUrlPathRoot()) return undefined

        const hash = window.location.hash.substr(1, window.location.hash.length)

        const isUrlParameter = Object.values(UIUrlParameterNames).some((param) => hash.startsWith(param))
        if(isUrlParameter) return undefined

        return hash?.toLocaleLowerCase()
    }

    static isUrlPathRoot(): boolean {
        const requiredFrontAndOptionalTrailingSlashRegex = new RegExp(String.raw`\/${UIUtilsEjsVariables.language}\/?`)
        const pathnameWithoutLanguage = location.pathname.replace(requiredFrontAndOptionalTrailingSlashRegex, '/')
        return pathnameWithoutLanguage == '/' || pathnameWithoutLanguage == '/mobile' || pathnameWithoutLanguage == '/.proxy/discord/web' || pathnameWithoutLanguage == '/.proxy/discord/mobile'
    }

    static extractHashAndValue(href: string): { hash: string | undefined, value: string | undefined } {
        const hashIndex = href.indexOf('#')
        if(hashIndex == -1 || hashIndex == href.length - 1) return {hash: undefined, value: undefined}
        const hashWithValue = href.slice(hashIndex + 1)
        const splitted = hashWithValue.split('=')
        return {
            hash: splitted[0],
            value: splitted.length > 1 ? splitted[1] : undefined,
        }
    }

    static getLanguagePrefix(): string {
        const languageMappings: Map<string, string> = new Map([
            ['zh', 'zh-CN'], ['pt', 'pt-PT'],
        ])
        const supportedLanguages = [...I18n.languages, ...languageMappings.keys()]
        const pathParts = window.location.pathname.split('/')
        if(pathParts.length < 2) return ''

        const language = pathParts[1]
        if(!supportedLanguages.includes(language)) return ''

        return language
    }

    static getPathnameWithoutLanguagePrefix(): string {
        const pathName = window.location.pathname
        const languagePrefix = this.getLanguagePrefix()
        if(!languagePrefix) return pathName

        const pathParts = pathName.split('/')
        return '/' + pathParts.slice(2).join('/')
    }

    static getRelativeUrlWithoutLanguagePrefix(): string {
        const pathName = this.getPathnameWithoutLanguagePrefix()
        const search = window.location.search
        const hash = window.location.hash
        return pathName + search + hash
    }
}
